module.exports = __webpack_public_path__ + "static/media/shapes.cedb6f34.png";